module.exports = __webpack_public_path__ + "static/media/koinpost.e47a7ec5.png";